import { RenewalContract, getRenewalContractsEndpoint } from '@cp-mx/common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<RenewalContract[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'renewalContract',
    fetchCallback() {
        return CpDataApi.get<RenewalContract[]>(getRenewalContractsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchRenewalContract = fetchData;
